import _ from 'lodash';

function reducer(state = [], action) {
  let index = 0;
  switch (action.type) {
    case 'ADJUSTMENTS/ADJUSTMENTS/SET':
      return action.adjustments;
    case 'ADJUSTMENTS/ADJUSTMENTS/CLEAR':
      return null;
    case 'ADJUSTMENT/UPDATE':
      index = _.findIndex(state, program => { return program.IdCatalogItemPriceAdjustmentByDate === action.program.IdCatalogItemPriceAdjustmentByDate });
      return [...state.slice(0, index), action.program, ...state.slice(index + 1)];
    case 'DIVISION/REMOVE_ADJUSTMENT':
      action.program.divisions = _.reject(action.program.divisions, (d) => { return d.IdDivision === action.division.IdDivision });
      // Update the store
      index = _.findIndex(state, program => { return program.IdCatalogItemPriceAdjustmentByDate === action.program.IdCatalogItemPriceAdjustmentByDate });
      return [...state.slice(0, index), action.program, ...state.slice(index + 1)];
    default:
      return state;
  }
}

export default reducer;
